import React from 'react';
import { cn } from '@/shared/utils/utils';

interface TeamCollaborationIllustrationProps {
  className?: string;
}

/**
 * Team collaboration illustration for debrief and team interactions
 */
export const TeamCollaborationIllustration: React.FC<
  TeamCollaborationIllustrationProps
> = ({ className }) => {
  return (
    <img
      src="/undraw-illustrations/undraw_team-collaboration_phnf.svg"
      alt="Team collaboration illustration"
      className={cn('object-contain w-1/4 2xl:w-1/2', className)}
    />
  );
};
